module.exports = __webpack_public_path__ + "images/emoji/a.ea5ce17fb19378709efe.png";